











































import { Component, Vue } from "vue-property-decorator";
import PortalInput from "@/components/common/PortalInput.vue";
import SingleFileHolder from "@/components/new_style_components/SingleFileHolder.vue";
import TaxObligationDTO from "@/dto/tax/TaxObligationDTO";
import TaxObligationPayload from "@/dto/tax/TaxObligationPayload";
import TaxObligationService from "@/services/TaxObligationService";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";

@Component({
  components: {
    PortalInput,
    SingleFileHolder
  }
})
export default class EditTaxObligationModal extends Vue {
  private taxObligationId: number | null = null;
  private form: TaxObligationPayload | null = null;

  beforeOpen(event: any) {
    const obligation = event.params.taxObligation as TaxObligationDTO;
    this.taxObligationId = obligation.id;
    
    // Initialize payload from existing DTO
    this.form = {
      year: obligation.year,
      period: obligation.period,
      periodStart: obligation.periodStart,
      periodEnd: obligation.periodEnd,
      reportFilingDeadline: obligation.reportFilingDeadline,
      paidOn: obligation.paidOn,
      status: obligation.status,
      obligation: obligation.obligation,
      paymentStatus: obligation.paymentStatus,
      risk: obligation.risk,
      nextAction: obligation.nextAction,
      assigneeId: obligation.assigneeId,
      taxReportForm: obligation.taxReportForm,
      state: obligation.state,
      customerId: obligation.customerId,
      customerType: obligation.customerType,
      submissionId: obligation.submissionId,
      filingDate: obligation.filingDate,
      document: obligation.document,
      liabilities: obligation.liabilities || []
    } as any;
  }

  closeModal() {
    this.$modal.hide("edit-tax-obligation-modal");
  }

  get isValid(): boolean {
    return !!this.form;
  }

  async submit() {
    if (!this.isValid || !this.taxObligationId || !this.form) return;

    Application.startLoading();
    TaxObligationService.updateTaxObligation(this.taxObligationId, this.form).then(
      () => {
        Application.stopLoading();
        this.$emit("updated");
        this.closeModal();
      },
      err => {
        Application.stopLoading();
        processError(err, this);
      }
    );
  }
}
